import React from "react";
import "./DocumentViewFooter.scss";

const DocumentViewFooter = ({
  viewOnly,
  uploadedFile,
  saveDisabled,
  cancelDisabled,
  handleSave,
  handleCancel,
  handleClose,
}) => {
  return (
    <div className="document-view-footer d-flex px-8 justify-content-end">
      <div className="d-flex ">
        {viewOnly && !uploadedFile ? (
          <button
            className="btn-secondary mx-2"
            id="overview_exit"
            onClick={handleClose}
          >
            Exit
          </button>
        ) : (
          <>
            <button
              className="btn-secondary mx-2"
              id="overview_cancel"
              disabled={cancelDisabled()}
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              // ref={addBtnRef}
              className="btn-primary mx-2"
              disabled={saveDisabled()}
              onClick={handleSave}
            >
              Save
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default DocumentViewFooter;
